import { gql } from '@apollo/client'

// just enough for the link builder to confirm a user id belongs to a real account, and show which twitch channel it streams to
export const lookupUser = gql`
  query LookupUser($id: ID!) {
    user: getUserById(id: $id) {
      id
      loungeUsername
      platformIdentifiers {
        platform
        gamerTag
        metadata {
          twitchStreamLink
          twitchStreamLiveStatus
          twitchProfile {
            profileImageUrl
          }
        }
      }
    }
  }
`
